import React from "react";
import { Drawer } from "antd";

const Modals = ({
  title,
  open,
  setOpen,
  children,
  footer,
  width,
  paddingCss,
}) => {
  const handleCancel = () => {
    setOpen(false);
  };

  return (
    // <Modal
    //   title={title || " "}
    //   open={open}
    //   onCancel={handleCancel}
    //   footer={footer}
    //   width={width ?? 700}
    // >
    <Drawer
      title={title || " "}
      onClose={handleCancel}
      open={open}
      footer={footer}
      width={width ?? 700}
    >
      {children ?? (
        <p style={{ padding: paddingCss }}>
          Lorem ipsum dolor, sit amet consectetur adipisicing elit. Aspernatur
          sunt natus, temporibus quidem quo quibusdam. Repudiandae reiciendis
          iste consectetur consequatur, sed, iusto fugiat vitae porro illum
          nobis at, obcaecati neque.
        </p>
      )}
    </Drawer>
    // </Modal>
  );
};

export default Modals;
